import Cookies from "js-cookie";
import { getCurrentEnviornment } from "utils/constants";

export async function APIHandlerPerformanceGolf({ method, url, data }: any) {
  const combineURL = (url: any) => {
    const baseUrl = process.env.REACT_APP_baseURL_performance_golf;
    return baseUrl + url;
  };

  let finalUrl = combineURL(url);
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: any = {
    method: method,
    headers: myHeaders,
    redirect: "follow",
  };

  if (method === "GET") {
    if (data) {
      const query = new URLSearchParams(data).toString();
      finalUrl = `${finalUrl}?${query}`;
    }
  } else {
    // ✅ Only attach body for non-GET
    requestOptions.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(finalUrl, requestOptions);
    const result = await response.text();
    const res = JSON.parse(result);

    if (res === "Logged Out") {
      Cookies.remove(`${getCurrentEnviornment()}_sessionToken`);
      localStorage.removeItem(`${getCurrentEnviornment()}_userId`);
      localStorage.removeItem(`${getCurrentEnviornment()}_userEmail`);
      window.location.replace("/");
    }

    return res; // Return the fetched data
  } catch (error) {
    console.error(error);
    throw error; // Rethrow the error for handling in the calling function
  }
}
